import { Flex } from "@chakra-ui/react";
import { useSlideInMenu } from "../../components/slideInMenu/hooks/useSlideInMenu";
import { SlideInHeader } from "../../components/slideInMenu/components/SlideInHeader";
import { SLIDE_IN_MENUS } from "../root/constants";
import { ArtistProfileContent } from "./ArtistProfileContent";

interface ArtistProfileProps {
  onCloseMenu?: () => void;
}

export function ArtistProfile({ onCloseMenu }: ArtistProfileProps) {
  const { artistSlug, goBack, navigationContext } = useSlideInMenu();

  return (
    <Flex flexDirection="column" height="100%">
      <SlideInHeader
        openMenu={SLIDE_IN_MENUS.publisher}
        onCloseMenu={onCloseMenu}
        handleBack={goBack}
      />
      <ArtistProfileContent
        artistSlug={artistSlug ?? ""}
        navigationContext={navigationContext}
        onCloseMenu={onCloseMenu}
      />
    </Flex>
  );
}
